/**
 * ./src/modules/product/components/icons/IconChevronDown.tsx
 *
 * IconChevronDown component to display an icon.
 *
 * @copyright DesignShop, 2024
 * @since 05/28/2024
 */
import React from 'react';

export const IconChevronDown = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.64645 9.64645C6.84171 9.45118 7.15829 9.45118 7.35355 9.64645L12 14.2929L16.6464 9.64645C16.8417 9.45118 17.1583 9.45118 17.3536 9.64645C17.5488 9.84171 17.5488 10.1583 17.3536 10.3536L12.3536 15.3536C12.1583 15.5488 11.8417 15.5488 11.6464 15.3536L6.64645 10.3536C6.45118 10.1583 6.45118 9.84171 6.64645 9.64645Z"
        fill="currentColor"
      />
    </svg>
  );
};
